<template>
  <div class="projects-info-list item-list item-report-summary">
    <div
      class="summary-toolbar"
      v-if="title"
    >
      <h2>{{title}} ({{total}})</h2>
    </div>

    <table class="no-row-border">
      <thead>
        <tr>
          <th>S.No</th>
          <th>Project</th>
          <th>Company</th>
          <th>Li.</th>
          <th>Bil.</th>
          <th>Created</th>
          <th v-if="$route.query.group !== 'verification'">P</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(project, index) in projects"
          :key="project.key"
          :class="[project.pending_status ? 'pending': '']"
        >
          <td>{{ index + 1 }}</td>
          <td>
            <ProjectItemName :project="project"
            @on-project-click="$emit('on-project-click', project)"/>
          </td>
          <td>
            <ProjectItemCompanyName :project="project" />
          </td>
          <td>
            <ProjectItemLicense :project="project"/>
          </td>
          <td>{{project.billingMediumShort}}</td>
          <td v-if="project.free_trail_detail && $route.query.group === 'trial'">
            {{ $filters.formatWithoutYear(project.free_trail_detail.trail_start) }} -
            {{ $filters.formatWithoutYear(project.free_trail_detail.trail_end) }}
          </td>
          <td v-else>
            {{ $filters.relativeShortDate(project.created) }}</td>
          <td v-if="$route.query.group !== 'verification'">
            <svg v-if="project.pending_status &&
            project.pending_status === 'payment_pending'">
              <use v-bind="{ 'xlink:href': '#payment-pending-icon' }" />
            </svg>
            <span v-else-if="project.pending_status &&
            project.pending_status !== 'payment_pending'">
              {{project.pending_status}}
            </span>
            <span v-else> - </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import ProjectItemCompanyName from './ProjectItemCompanyName.vue';
import ProjectItemName from './ProjectItemName.vue';
import ProjectItemLicense from './ProjectItemLicense.vue';

export default {
  props: {
    projects: Object,
    title: {
      type: String,
      default: '',
    },
    total: {
      type: String,
      default: '',
    },
  },
  components: {
    ProjectItemCompanyName,
    ProjectItemName,
    ProjectItemLicense,
  },
};
</script>
